<template>
    <div>


        <v-data-table 
            :headers="headers" 
            :items="itemsPage.data" 
            :total-items="totalItems" 
            :loading="loading" 
            :pagination.sync="pagination"
            class="elevation-1" 
            
            >
            <template v-slot:items="props">
                <td class="text-xs-center">{{ props.item.id }}</td>
                <td>{{ props.item.persona[0].nombre }} {{ props.item.persona[0].apellido }}</td>
                <td>{{ props.item.documento }}</td>
                <td>{{ props.item.created_at ? formatDateTime(props.item.created_at) : '' }}</td>
                <td>{{ props.item.updated_at ? formatDate(props.item.updated_at) : '' }}</td>
                <td>
                    <v-btn depressed small :color="getColorEstado(props.item.estado)">
                        {{ getNombreEstado(props.item.estado) }}
                    </v-btn>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon 
                                v-if="props.item.razon_rechazo" 
                                small 
                                v-bind="attrs" 
                                v-on="on"
                            >info</v-icon>
                        </template>
                        <span v-if="props.item.razon_rechazo">Razón: {{ props.item.razon_rechazo }}</span>
                    </v-tooltip>

                </td>
                <td>
                    <v-icon @click.stop="abrirValidacionFirma(props.item)" title="Ver" small>visibility</v-icon>
                </td>
            </template>
            <template slot="pageText" slot-scope="props">
            Aptos enviados desde {{ props.pageStart }} a {{ props.pageStop }} de {{
                props.itemsLength }}
        </template>
        </v-data-table>
    </div>
</template>

<script>
import aptosMedicosApi from '../../../../../api/aptos';
import moment from 'moment';

export default {
    name: "ListaAptosMedicosTabla",
    props: {
        evento_id: {
            type: String,
            default: null
        },
    },

    data() {
        return {
            totalItems: 0,   
            pagination: {
                descending: false,
                page: 1,
                rowsPerPage: 25,
                sortBy: "id",
                totalItems: 10
            },
            filters: {
                firstname: '',
                lastname: '',
                document: '',
                status: ''
            },
            loading: false,
            itemsPage: {
                data: [],
                total: 0,
            },
            headers: [
                {
                    text: 'Id',
                    align: 'start',
                    sortable: false,
                    value: 'nombre',
                },
                { text: 'Nombre y apellido', value: 'nombre_completo', sortable: false  },
                { text: 'Documento', value: 'documento', sortable: false },
                { text: 'Fecha Subida', value: 'created_at', sortable: false, },
                { text: 'Ult.actualizacion', value: 'updated_at', sortable: false, },
                { text: 'Estado', value: 'state', sortable: false, },
                { text: 'Acciones', value: 'acciones', sortable: false }
            ],
        }
    },
    mounted() {
        this.loadData();
    },
    watch: {
        pagination: {
            handler() {
                console.log("PAGINATION", this.pagination);                 
                this.loadData();                    
            },
            deep: true,
        },
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('DD/MM/YYYY');
        },
        loadData() {
            this.loading = true;
            const params = {};

            if (this.filters.firstname) {
                params.firstname = this.filters.firstname;
            }
            if (this.filters.lastname) {
                params.lastname = this.filters.lastname;
            }


            if (this.filters.document) {
                params.document = this.filters.document;
            }
            if (this.filters.status) {
                params.status = this.filters.status;
            }
            if (this.pagination.page) {
                params.page = this.pagination.page;
            }

            aptosMedicosApi.getAptos(this.evento_id, params)
                .then(response => {
                    this.itemsPage = response;
                
                    this.totalItems = response.total;

                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    console.error("Error al cargar los aptos medicos:", error);
                });
        },
        applyFilters(filters) {
            this.filters = filters;
            this.loadData();
        },
        abrirValidacionFirma(persona) {
            console.log('Validar Apto:', persona);
            this.$emit('validarApto', persona);
        },
        getColorEstado(estado) {
            switch (estado) {
                case 'PENDING':
                    return 'orange';
                case 'APPROVED':
                    return 'green';
                case 'REJECTED':
                    return 'red';
                default:
                    return 'grey';
            }
        },

        getNombreEstado(estado) {
            switch (estado) {
                case 'PENDING':
                    return 'Pendiente';
                case 'APPROVED':
                    return 'Aprobado';
                case 'REJECTED':
                    return 'Rechazado';
                default:
                    return 'Desconocido';
            }
        },
        formatDateTime(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('DD/MM/YYYY HH:mm');
        },
        updateFilters(filters) {
            this.filters = filters;
            this.loadData();
        }
    },

}
</script>

<style scoped>
/* Component styles can be added here */
</style>
